<template>
  <div>
    <el-dialog :title="$t('Creando Usuario')" :visible.sync="visibleSync" :before-close="onCancel">
      <el-form :model="user">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Rut">
              <el-input v-model="user.rut"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Correo')">
              <el-input v-model="user.email" :disabled="action !== 'create' || findUser === true"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Nombre')">
              <el-input v-model="user.nombre" :disabled="findUser === true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Apellido')">
              <el-input v-model="user.apellido" :disabled="findUser === true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="aceptar">{{ $t('Guardar Cambios') }}</el-button>
        <el-button @click="onCancel">{{ $t('Cerrar') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      innerDialogRoles: false,
      auxAC: {
        title: '',
        acs: [],
        roles: {},
      },
      auxUserACRoles: {
        type: 'bhp',
        key: '',
        roles: [],
      },
      bhpRoles: {
        hse: { role: 'HSE', disabled: false },
        owner: { role: 'Dueño de contrato', disabled: false },
        risk: { role: 'Especialista de Riesgos', disabled: false },
        coordinator: { role: 'Coordinador', disabled: false },
        super: { role: 'Superintendente', disabled: true },
        manager: { role: 'Gerente', disabled: true },
      },
      contractorRoles: {
        contractor_hse: { role: 'HSE', disabled: false },
        administrator: { role: 'Administrador de contrato', disabled: false },
        contractor_coordinator: { role: 'Coordinador', disabled: false },
      },
    }
  },
  props: ['user', 'visibleSync', 'onAcept', 'onCancel', 'action', 'findUser'],
  methods: {
    aceptar() {
      this.onAcept(this.action)
    },
    setAuxRole(type, key = '', roles = []) {
      if (type === 'bhp') {
        this.auxAC.title = 'Área';
        this.auxAC.acs = this.$store.getters.areas;
        this.auxAC.roles = this.bhpRoles;
      } else {
        this.auxAC.title = 'Empresa';
        this.auxAC.acs = this.$store.getters.empresas;
        this.auxAC.roles = this.contractorRoles;
      }
      this.auxUserACRoles = { type, key, roles };
      this.innerDialogRoles = true;
    },
  }
};
</script>

<style scoped>
</style>
